import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import FormField from "../../Helpers/FormField";
import {input} from "../../../utils/linker";

function Resize(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  if(typeof props.linker.value !== "object") {
    runInAction(()=>{
      props.linker.value = {};
    });
  }


  return (
      <FormField title={props.option.name} description={props.option.description}>
        <div className="up12 margin">
          <div className="cell s-6">Уменьшать до:</div>
          <div className="cell s-6">Качество при уменьшении:</div>
          <div className="cell s-6">
            <input type="text" className="w100" {...input(props.linker.value, "mode")} />
          </div>
          <div className="cell s-6">
            <input type="text" className="w100" {...input(props.linker.value, "quality")} />
          </div>
        </div>
      </FormField>
  )
};

Resize.defaultProps = {};

Resize.propTypes = {}

export default observer(Resize);
